import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout only: /palworld-tcg renders the hub, /palworld-tcg/<slug> an answer page. */
export const Route = createFileRoute("/palworld-tcg")({
  component: Outlet,
});
